import React from 'react';
import './field-desc.scss';

type Props = {
  placeholder?: string
  value?: string
};

const FieldDesc = ({ placeholder } : Props): JSX.Element => {

  return (
    <div data-testid="FieldDesc" className="field-desc-container ">
      <span className="field-desc-container-value">
        {placeholder}
      </span>
    </div>
  );
};

export default FieldDesc;
